<div class="search">
    <label>ค้นหา: </label>
    <mat-form-field>
        <input matInput (keyup)="applyFilter($event)" #input>
    </mat-form-field>
</div>
<div class="mat-elevation-z8">
    <table mat-table [dataSource]="dataSource" matSort>

        <!-- Name Column -->
        <ng-container matColumnDef="name">
            <th mat-header-cell *matHeaderCellDef mat-sort-header> ชื่อสินค้า </th>
            <td mat-cell *matCellDef="let element"> {{element.name}} </td>
        </ng-container>

        <!-- Front Store Price Column -->
        <ng-container matColumnDef="front_store_price">
            <th mat-header-cell *matHeaderCellDef mat-sort-header> ราคาหน้าร้าน </th>
            <td mat-cell *matCellDef="let element"> {{element.front_store_price | number}} </td>
        </ng-container>

        <!-- wholesale Price Column -->
        <ng-container matColumnDef="wholesale_price">
            <th mat-header-cell *matHeaderCellDef mat-sort-header> ราคาขายส่ง </th>
            <td mat-cell *matCellDef="let element"> {{element.wholesale_price | number}} </td>
        </ng-container>

        <!-- Unit Type Price Column -->
        <ng-container matColumnDef="unit_type">
            <th mat-header-cell *matHeaderCellDef mat-sort-header> หน่วย </th>
            <td mat-cell *matCellDef="let element"> {{element.unit_type}} </td>
        </ng-container>

        <ng-container matColumnDef="option">
            <th mat-header-cell *matHeaderCellDef mat-sort-header> ตัวเลือก </th>
            <td mat-cell *matCellDef="let element">
                <a (click)="editProduct(element.barcode)">
                    <mat-icon aria-hidden="false" aria-label="edit icon">edit</mat-icon>
                </a>
                <a (click)="openDialog(element)">
                    <mat-icon aria-hidden="false" aria-label="receive product">inventory</mat-icon>
                </a>
            </td>
        </ng-container>
        <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
        <tr mat-row *matRowDef="let row; columns: displayedColumns;"></tr>

        <tr class="mat-row" *matNoDataRow>
            <td class="mat-cell" colspan="4">ไม่มีสินค้า "{{input.value}}" ในระบบ</td>
        </tr>
    </table>
    <mat-paginator [pageSizeOptions]="[20, 50, 100]" [pageSize]="20"></mat-paginator>
</div>